import { Circle, Text } from 'native-base';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useCallback, useState } from 'react';
import { TwIcon, TwRow, TwStackedCard } from '@tw/tw-components-rn';

import { ProductGoodsDTO } from '@tw/clvip-api-gen';
import { styles } from './styles';

interface GoodLimitTagProps {
  chooseLimitMax: number;
}

export const GoodLimitTag = (props: GoodLimitTagProps) => {
  return <Text style={styles.subtitleTag}>{'限' + props.chooseLimitMax + '份'}</Text>;
};
